import React from 'react';

import { RichHtmlContent } from '../../../components/RichHtmlContent';

interface SummaryRichTextValueProps {
  html: string;
  requestId?: string;
  testID?: string;
}

export const SummaryRichTextValue: React.FC<SummaryRichTextValueProps> = ({
  html,
  requestId,
  testID,
}) => {
  if (!html.trim()) {
    return null;
  }

  return <RichHtmlContent value={html} requestId={requestId} testID={testID} />;
};
